import { gql } from "gql";

export const GET_CHILDREN_FROM_NODE = gql(/* GraphQL */ `
  query CompanyStructureSelectGetChildrenFromNode(
    $hierarchyType: HierarchyType!
    $id: ID!
    $types: [HierarchyElementType]
  ) {
    getHierarchyElementById(hierarchyType: $hierarchyType, id: $id) {
      id
      ...CompanyStructureSelectOption

      hierarchy(type: $hierarchyType) {
        allChildren(types: $types) {
          ...CompanyStructureSelectOption
        }
      }
    }
  }
`);
